import moment from 'moment-timezone';

export const MaskInputHelper = {
  unmaskLaser: (laser) => {
    return laser?.replace(/-/g, '');
  },

  unmaskMobilePhone: (mobilePhone) => {
    return mobilePhone?.replace(/-/g, '');
  },

  unmaskIdCard: (idCard) => {
    return idCard?.replace(/ /g, '');
  },

  formatNumber: (value) => {
    return value !== undefined && value !== null ? Number(value).toLocaleString() : '';
  },

  formatRemainingTime: (duration) => {
    return `${duration.minutes()} : ${duration.seconds().toString().padStart(2, '0')}`;
  }
};
